import Vue from 'vue'
import VueJsonToCsv from 'vue-json-to-csv'

Vue.component('vue-json-to-csv', VueJsonToCsv)
